var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 29
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v28.8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.2 11.65a7.97 7.97 0 001.092 4.024c.8 1.376 2.633 4.21 5.498 8.498a1.8 1.8 0 002.993 0c2.865-4.289 4.698-7.122 5.5-8.498a7.968 7.968 0 001.09-4.025c0-4.444-3.62-8.049-8.087-8.049C4.821 3.6 1.2 7.205 1.2 11.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#195DEE",
    d: "M9.286 14.213a2.528 2.528 0 010-5.054 2.528 2.528 0 010 5.054z"
  }))));
}
export default SvgPinWhite;